import { cn } from "@repo/utils";
import type { ReactNode } from "react";

interface OptionCopsoq3Props {
  label: string;
  selectionne: boolean;
  disabled: boolean;
  onClick: () => void;
  /** Pastille devant le libellé : lettre (partie 2), rond ou case (partie 1). */
  indicateur: ReactNode;
  compact?: boolean;
}

/** Une option cliquable du COPSOQ III, commune aux parties 1 et 2. */
export function OptionCopsoq3({
  label,
  selectionne,
  disabled,
  onClick,
  indicateur,
  compact = false,
}: OptionCopsoq3Props) {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={selectionne}
      onClick={onClick}
      className={cn(
        "flex items-center w-full rounded-controle border-2 text-left transition-all duration-150",
        "focus:outline-none focus-visible:border-primary",
        compact ? "gap-3 px-4 py-3" : "gap-4 px-5 py-4",
        selectionne
          ? "border-primary bg-primary/10 text-primary font-medium"
          : "border-transparent bg-surface-2 hover:border-charte-line-accent hover:bg-charte-hover-strong",
        disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer",
      )}
    >
      {indicateur}
      <span className="text-sm leading-snug">{label}</span>
    </button>
  );
}

/** Pastille devant le libellé : la lettre de l'option en partie 2, l'état
 * coché en partie 1. */
export function PastilleOption({
  selectionne,
  carre = false,
  children,
}: {
  selectionne: boolean;
  /** Case à cocher (choix multiple) plutôt que rond. */
  carre?: boolean;
  children?: ReactNode;
}) {
  return (
    <span
      className={cn(
        "flex h-6 w-6 shrink-0 items-center justify-center border-2 text-xs font-bold transition-colors",
        carre ? "rounded-md" : "rounded-full",
        selectionne
          ? "border-primary bg-primary text-primary-foreground"
          : "border-muted-foreground text-muted-foreground",
      )}
    >
      {children}
    </span>
  );
}
